import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const TabsContentCard = styled.div`
    padding: 20px 0 0;
    display: flex;
    flex-direction: column;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const TabPlaceholder = styled.div`
    padding: 20px;
    color: ${colors.textSecondary};
    font-size: 14px;
`;
